import React from 'react';
import { Building2, FolderKanban, ShieldCheck, ShieldAlert, Eye } from 'lucide-react';
import { Card } from '../../../components/ui/Card';
import { Badge } from '../../../components/ui/Badge';
import { InvitationDetails } from '../types';

interface InviteContextCardProps {
  invite: InvitationDetails;
}

export const InviteContextCard: React.FC<InviteContextCardProps> = ({ invite }) => {
  return (
    <Card className="mb-6 p-3.5 bg-cf-bg border border-cf-border space-y-2 text-xs shadow-xs">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5 text-cf-textSecondary font-medium">
          <Building2 size={13} className="text-cf-orange" />
          <span>Organization</span>
        </div>
        <span className="font-semibold text-cf-textPrimary">
          {invite.organization_name || 'Ericius Organization'}
        </span>
      </div>

      <div className="flex items-center justify-between">
        <span className="text-cf-textSecondary font-medium">Invited Role</span>
        <span className="font-semibold text-cf-textPrimary capitalize">
          {invite.role || 'Member'}
        </span>
      </div>

      {invite.project_name && (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-cf-textSecondary font-medium">
            <FolderKanban size={13} className="text-cf-orange" />
            <span>Assigned Project</span>
          </div>
          <span className="text-cf-textPrimary text-xs">{invite.project_name}</span>
        </div>
      )}

      <div className="flex items-center justify-between pt-1 border-t border-cf-border/60">
        <span className="text-cf-textSecondary font-medium">Permission Tier</span>
        <Badge
          size="xs"
          variant={
            invite.permission_tier === 'full'
              ? 'info'
              : invite.permission_tier === 'edit'
              ? 'warning'
              : 'default'
          }
          className="uppercase"
        >
          {invite.permission_tier === 'full' && <ShieldCheck size={11} className="mr-1" />}
          {invite.permission_tier === 'edit' && <ShieldAlert size={11} className="mr-1" />}
          {invite.permission_tier === 'read' && <Eye size={11} className="mr-1" />}
          <span>{invite.permission_tier} tier</span>
        </Badge>
      </div>
    </Card>
  );
};
